// Mock data para demonstração do Orçamento na Hora

// ============================================
// CONFIGURAÇÃO DE MARCENARIA (Metro Linear)
// ============================================

// Ambientes padrão com altura técnica (oculta do cliente)
export const marcenariaAmbientes = [
  { id: 'cozinha', nome: 'Cozinha', altura: 2.50, fatorTecnico: 2.5 },
  { id: 'quarto', nome: 'Quarto', altura: 2.40, fatorTecnico: 2.4 },
  { id: 'closet', nome: 'Closet', altura: 2.30, fatorTecnico: 2.3 },
  { id: 'banheiro', nome: 'Banheiro', altura: 2.20, fatorTecnico: 2.2 },
  { id: 'sala', nome: 'Sala', altura: 2.40, fatorTecnico: 2.4 },
  { id: 'lavanderia', nome: 'Lavanderia', altura: 2.30, fatorTecnico: 2.3 },
  { id: 'escritorio', nome: 'Escritório', altura: 2.40, fatorTecnico: 2.4 },
];

// Materiais com preço sugerido por metro linear
export const marcenariaMateriais = [
  { id: 'mdp_basico', nome: 'MDP Básico', precoSugerido: 900, descricao: 'Econômico, boa durabilidade' },
  { id: 'mdf_branco', nome: 'MDF Branco', precoSugerido: 1100, descricao: 'Versátil, acabamento liso' },
  { id: 'mdf_amadeirado', nome: 'MDF Amadeirado', precoSugerido: 1300, descricao: 'Padrão madeira, elegante' },
  { id: 'mdf_premium', nome: 'MDF Premium / Cores', precoSugerido: 1600, descricao: 'Alto padrão, cores especiais' },
  { id: 'mdf_lacado', nome: 'MDF Lacado', precoSugerido: 2000, descricao: 'Acabamento laqueado, premium' },
];

// Adicionais com valores sugeridos (% ou fixo por metro linear)
export const marcenariaAdicionais = [
  { id: 'led', nome: 'Iluminação LED', tipo: 'ml', valorSugerido: 180, descricao: 'Fita LED embutida' },
  { id: 'corredica_oculta', nome: 'Corrediça Oculta', tipo: 'percentual', valorSugerido: 10, descricao: 'Gavetas soft close' },
  { id: 'amortecedor', nome: 'Portas com Amortecedor', tipo: 'percentual', valorSugerido: 8, descricao: 'Fechamento suave' },
  { id: 'vidro', nome: 'Portas com Vidro', tipo: 'ml', valorSugerido: 250, descricao: 'Vidro temperado' },
  { id: 'laca', nome: 'Acabamento em Laca', tipo: 'percentual', valorSugerido: 25, descricao: 'Pintura laqueada' },
  { id: 'espelho', nome: 'Espelho', tipo: 'ml', valorSugerido: 200, descricao: 'Espelho colado nas portas' },
  { id: 'puxador_gola', nome: 'Puxador Gola (Cava)', tipo: 'ml', valorSugerido: 80, descricao: 'Sem puxadores aparentes' },
];

// Texto de transparência para o cliente
export const marcenariaTextoTransparencia = 
  "O valor apresentado é um orçamento estimado, calculado por metro linear, considerando altura padrão do ambiente e os materiais selecionados. Após a visita técnica e conferência das medidas finais, o valor poderá sofrer ajustes.";

// Templates de negócios pré-configurados
export const businessTemplates = [
  {
    id: 'marcenaria',
    name: 'Marcenaria',
    icon: 'Hammer',
    description: 'Móveis planejados por metro linear',
    isMarcenaria: true, // Flag para identificar
    services: [], // Marcenaria usa sistema especial
    // Configuração padrão de marcenaria
    marcenariaConfig: {
      ambientes: marcenariaAmbientes.map(a => ({ ...a, ativo: true })),
      materiais: marcenariaMateriais.map(m => ({ ...m, preco: m.precoSugerido, ativo: true })),
      adicionais: marcenariaAdicionais.map(a => ({ ...a, valor: a.valorSugerido, ativo: true })),
      textoTransparencia: marcenariaTextoTransparencia
    }
  },
  {
    id: 'montagem',
    name: 'Montagem de Móveis',
    icon: 'Wrench',
    description: 'Montagem e assistência técnica',
    services: [
      { id: 1, name: 'Montagem guarda-roupa 2 portas', price: 120, unit: 'unidade' },
      { id: 2, name: 'Montagem guarda-roupa 4 portas', price: 180, unit: 'unidade' },
      { id: 3, name: 'Montagem guarda-roupa 6 portas', price: 250, unit: 'unidade' },
      { id: 4, name: 'Montagem cama box', price: 80, unit: 'unidade' },
      { id: 5, name: 'Montagem beliche', price: 120, unit: 'unidade' },
      { id: 6, name: 'Montagem rack/estante', price: 100, unit: 'unidade' },
      { id: 7, name: 'Montagem cômoda', price: 70, unit: 'unidade' },
      { id: 8, name: 'Montagem mesa de escritório', price: 90, unit: 'unidade' },
      { id: 9, name: 'Instalação painel TV', price: 80, unit: 'unidade' },
      { id: 10, name: 'Deslocamento (por km)', price: 2.5, unit: 'km' },
    ]
  },
  {
    id: 'oficina',
    name: 'Oficina Mecânica',
    icon: 'Car',
    description: 'Serviços automotivos',
    services: [
      { id: 1, name: 'Troca de óleo (mão de obra)', price: 50, unit: 'serviço' },
      { id: 2, name: 'Alinhamento', price: 80, unit: 'serviço' },
      { id: 3, name: 'Balanceamento (por roda)', price: 30, unit: 'unidade' },
      { id: 4, name: 'Troca de pastilha de freio', price: 120, unit: 'serviço' },
      { id: 5, name: 'Troca de amortecedor (par)', price: 200, unit: 'serviço' },
      { id: 6, name: 'Revisão completa', price: 350, unit: 'serviço' },
      { id: 7, name: 'Diagnóstico eletrônico', price: 100, unit: 'serviço' },
    ]
  },
  {
    id: 'eletricista',
    name: 'Eletricista',
    icon: 'Zap',
    description: 'Instalações elétricas',
    services: [
      { id: 1, name: 'Instalação de tomada', price: 60, unit: 'ponto' },
      { id: 2, name: 'Instalação de interruptor', price: 50, unit: 'ponto' },
      { id: 3, name: 'Instalação de lustre/luminária', price: 80, unit: 'unidade' },
      { id: 4, name: 'Instalação de chuveiro elétrico', price: 120, unit: 'unidade' },
      { id: 5, name: 'Instalação de ar condicionado', price: 250, unit: 'unidade' },
      { id: 6, name: 'Troca de disjuntor', price: 70, unit: 'unidade' },
      { id: 7, name: 'Visita técnica', price: 100, unit: 'visita' },
    ]
  },
  {
    id: 'pintor',
    name: 'Pintor',
    icon: 'Paintbrush',
    description: 'Pintura residencial e comercial',
    services: [
      { id: 1, name: 'Pintura de parede (m²)', price: 25, unit: 'm²' },
      { id: 2, name: 'Pintura de teto (m²)', price: 30, unit: 'm²' },
      { id: 3, name: 'Pintura de porta', price: 80, unit: 'unidade' },
      { id: 4, name: 'Pintura de janela', price: 100, unit: 'unidade' },
      { id: 5, name: 'Textura (m²)', price: 45, unit: 'm²' },
      { id: 6, name: 'Massa corrida (m²)', price: 20, unit: 'm²' },
    ]
  },
  {
    id: 'personalizado',
    name: 'Personalizado',
    icon: 'Settings',
    description: 'Configure seus próprios serviços',
    services: []
  }
];

// Profissional de demonstração
export const demoProfessional = {
  id: 'demo-123',
  slug: 'joao-montador',
  name: 'João Montador',
  business: 'Montagem Express',
  phone: '24999999999',
  email: 'joao@montagem.com',
  logo: null,
  template: 'montagem',
  services: [
    { id: 1, name: 'Montagem guarda-roupa 2 portas', price: 120, unit: 'unidade' },
    { id: 2, name: 'Montagem guarda-roupa 4 portas', price: 180, unit: 'unidade' },
    { id: 3, name: 'Montagem guarda-roupa 6 portas', price: 250, unit: 'unidade' },
    { id: 4, name: 'Montagem cama box', price: 80, unit: 'unidade' },
    { id: 5, name: 'Montagem beliche', price: 120, unit: 'unidade' },
    { id: 6, name: 'Montagem rack/estante', price: 100, unit: 'unidade' },
    { id: 7, name: 'Montagem cômoda', price: 70, unit: 'unidade' },
    { id: 8, name: 'Deslocamento (por km)', price: 2.5, unit: 'km' },
  ],
  createdAt: new Date().toISOString()
};

// Função para formatar preço
export const formatPrice = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

// Função para gerar slug
export const generateSlug = (name) => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

// Função para formatar metros lineares (entrada do cliente)
// Converte "450" -> "4,50" automaticamente
export const formatMetrosLineares = (value) => {
  // Remove tudo que não é número
  const numbers = value.replace(/\D/g, '');
  
  if (!numbers) return '';
  
  // Se tiver menos de 3 dígitos, considera centímetros
  if (numbers.length <= 2) {
    return `0,${numbers.padStart(2, '0')}`;
  }
  
  // Separa metros e centímetros
  const metros = numbers.slice(0, -2);
  const centimetros = numbers.slice(-2);
  
  return `${parseInt(metros)},${centimetros}`;
};

// Função para parsear metros lineares (string -> number)
export const parseMetrosLineares = (formatted) => {
  if (!formatted) return 0;
  // Converte "4,50" -> 4.50
  return parseFloat(formatted.replace(',', '.')) || 0;
};

// Função para calcular orçamento de marcenaria
export const calcularOrcamentoMarcenaria = (config) => {
  const { ambiente, metrosLineares, material, adicionaisSelecionados, marcenariaConfig } = config;
  
  // Encontra o material selecionado
  const materialSelecionado = marcenariaConfig.materiais.find(m => m.id === material && m.ativo);
  if (!materialSelecionado) return { total: 0, detalhes: [] };
  
  // Calcula valor base (metros lineares x preço do material)
  const valorBase = metrosLineares * materialSelecionado.preco;
  
  const detalhes = [
    {
      descricao: `${metrosLineares.toFixed(2).replace('.', ',')} ml × ${materialSelecionado.nome}`,
      valor: valorBase
    }
  ];
  
  let total = valorBase;
  let totalAdicionaisPercentual = 0;
  let totalAdicionaisFixo = 0;
  
  // Calcula adicionais
  adicionaisSelecionados.forEach(adicionalId => {
    const adicional = marcenariaConfig.adicionais.find(a => a.id === adicionalId && a.ativo);
    if (!adicional) return;
    
    if (adicional.tipo === 'percentual') {
      totalAdicionaisPercentual += adicional.valor;
    } else {
      // Tipo 'ml' - valor fixo por metro linear
      const valorAdicional = metrosLineares * adicional.valor;
      totalAdicionaisFixo += valorAdicional;
      detalhes.push({
        descricao: `${adicional.nome} (${metrosLineares.toFixed(2).replace('.', ',')} ml × R$ ${adicional.valor})`,
        valor: valorAdicional
      });
    }
  });
  
  // Aplica percentuais sobre o valor base
  if (totalAdicionaisPercentual > 0) {
    const valorPercentual = valorBase * (totalAdicionaisPercentual / 100);
    total += valorPercentual;
    detalhes.push({
      descricao: `Adicionais (+${totalAdicionaisPercentual}%)`,
      valor: valorPercentual
    });
  }
  
  total += totalAdicionaisFixo;
  
  return { total, detalhes, valorBase };
};
